<template>
  <b-modal
    v-model="value"
    @input="$emit('input', $event)"
    hide-footer
    title="Thêm mới thương hiệu"
  >
    <b-row class="mb-5">
      <b-col>
        <label class="labelInput">Tên thương hiệu:</label>
        <b-form-input
          size="sm"
          v-model="localBrandName"
          placeholder="Nhập tên thương hiệu"
          @input="updateBrandName"
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-button
          style="fontweight: 600; width: 70px"
          variant="primary"
          size="sm"
          @click="$emit('save')"
          >Lưu</b-button
        >
        <b-button
          @click="$emit('input', false)"
          style="margin-left: 10px; font-weight: 600; width: 70px"
          variant="secondary"
          size="sm"
          >Hủy</b-button
        >
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: 'BrandModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    brandName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localBrandName: this.brandName,
    };
  },
  watch: {
    brandName(val) {
      this.localBrandName = val;
    },
    value(val) {
      if (val) {
        this.localBrandName = this.brandName;
      }
    },
  },
  methods: {
    updateBrandName(value) {
      this.$emit('update:brandName', value);
    },
  },
};
</script>
